export enum Launch_Booming {
  "hu" = "hu",
}
